<template>
    <div class="bg-base-200 h-screen-header rounded-xl p-2 overflow-y-auto">
        <!-- 主内容区 -->
        <main class="">
            <div class="flex">
                <div class="flex-1">
                    <!-- 顶部导航栏 -->
                    <header class="p-4 flex items-center justify-between">
                        <div class="flex items-center space-x-4">
                            <a href="#" class="text-base-content/60 hover:text-base-content">发现音乐</a>
                        </div>
                    </header>
                    <!-- 艺术家封面 -->
                    <div class="relative">
                        <div class="h-32 md:h-48 2xl:h-96 p-8 rounded-xl"
                            style="background-image: url('https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=1200&h=400&fit=crop'); background-size: cover; background-position: center;">
                            <div class="flex items-center space-x-2 mb-4">
                                <i class="fas fa-check-circle text-primary"></i>
                                <span class="text-sm text-base-100">verified user</span>
                            </div>
                            <h1 class="text-6xl font-bold mb-4 text-base-100">White Lies</h1>
                            <div class="flex items-center space-x-2 text-base-100">
                                <i class="fas fa-users"></i>
                                <span>1,322,931 listeners for the month</span>
                            </div>
                        </div>
                    </div>

                    <!-- 热度艺术家 -->
                    <section class="p-8">
                        <h2 class="text-2xl font-bold mb-6 flex items-center text-base-content">
                            <i class="fas fa-chart-line text-primary mr-3"></i>
                            Trending Artists
                        </h2>
                        <div class="grid grid-cols-3 gap-6">
                            <div
                                class="bg-base-100 rounded-lg overflow-hidden group cursor-pointer shadow-lg hover:shadow-xl transition-shadow">
                                <div class="relative">
                                    <img src="https://images.unsplash.com/photo-1593697821252-0c9137d9fc45?w=400&h=200&fit=crop"
                                        class="w-full h-40 object-cover opacity-80 group-hover:opacity-100 transition-opacity">
                                    <div
                                        class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent to-[#1e2329]">
                                    </div>
                                    <div
                                        class="absolute top-4 right-4 bg-base-100 bg-opacity-70 rounded-full px-2 py-1 text-xs">
                                        <i class="fas fa-fire text-green-500 mr-1"></i>
                                        <span>TOP 1</span>
                                    </div>
                                </div>
                                <div class="p-4">
                                    <div class="flex items-center justify-between mb-2">
                                        <h3 class="font-bold text-xl text-base-content">Taylor Swift</h3>
                                        <span class="text-primary flex items-center text-sm">
                                            <i class="fas fa-user-friends mr-1"></i>
                                            65.4M
                                        </span>
                                    </div>
                                    <p class="text-base-content/60 mb-2">Pop, Country, Folk</p>
                                    <div class="flex items-center text-base-content/60 text-sm">
                                        <i class="fas fa-music mr-2"></i>
                                        <span>Latest: The Tortured Poets Department</span>
                                    </div>
                                    <button class="w-full mt-4 py-2 px-4 btn btn-primary btn-sm">
                                        View Artist
                                    </button>
                                </div>
                            </div>

                            <div class="bg-base-100 rounded-lg overflow-hidden group cursor-pointer">
                                <div class="relative">
                                    <img src="https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=400&h=200&fit=crop"
                                        class="w-full h-40 object-cover opacity-80 group-hover:opacity-100 transition-opacity">
                                    <div
                                        class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent to-[#1e2329]">
                                    </div>
                                    <div
                                        class="absolute top-4 right-4 bg-base-100 bg-opacity-70 rounded-full px-2 py-1 text-xs">
                                        <i class="fas fa-fire text-green-500 mr-1"></i>
                                        <span>TOP 2</span>
                                    </div>
                                </div>
                                <div class="p-4">
                                    <div class="flex items-center justify-between mb-2">
                                        <h3 class="font-bold text-xl">The Weeknd</h3>
                                        <span class="text-green-500 flex items-center text-sm">
                                            <i class="fas fa-user-friends mr-1"></i>
                                            52.7M
                                        </span>
                                    </div>
                                    <p class="text-gray-400 mb-2">R&B, Pop, Synthwave</p>
                                    <div class="flex items-center text-gray-400 text-sm">
                                        <i class="fas fa-music mr-2"></i>
                                        <span>Latest: Blinding Lights Latest: The </span>
                                    </div>
                                    <button class="w-full mt-4 py-2 px-4 btn btn-primary btn-sm">
                                        View Artist
                                    </button>
                                </div>
                            </div>

                            <div class="bg-base-100 rounded-lg overflow-hidden group cursor-pointer">
                                <div class="relative">
                                    <img src="https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=400&h=200&fit=crop"
                                        class="w-full h-40 object-cover opacity-80 group-hover:opacity-100 transition-opacity">
                                    <div
                                        class="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-transparent to-[#1e2329]">
                                    </div>
                                    <div
                                        class="absolute top-4 right-4 bg-base-100 bg-opacity-70 rounded-full px-2 py-1 text-xs">
                                        <i class="fas fa-fire text-green-500 mr-1"></i>
                                        <span>TOP 3</span>
                                    </div>
                                </div>
                                <div class="p-4">
                                    <div class="flex items-center justify-between mb-2">
                                        <h3 class="font-bold text-xl">Billie Eilish</h3>
                                        <span class="text-green-500 flex items-center text-sm">
                                            <i class="fas fa-user-friends mr-1"></i>
                                            48.3M
                                        </span>
                                    </div>
                                    <p class="text-gray-400 mb-2">Alternative, Electropop</p>
                                    <div class="flex items-center text-gray-400 text-sm">
                                        <i class="fas fa-music mr-2"></i>
                                        <span>Latest: HIT ME HARD AND SOFT</span>
                                    </div>
                                    <button class="w-full mt-4 py-2 px-4 btn btn-primary btn-sm">
                                        View Artist
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- 热门歌曲列表 -->
                    <section class="p-8">
                        <h2 class="text-2xl font-bold mb-6 flex items-center text-base-content">
                            <i class="fas fa-fire text-primary mr-3"></i>
                            热门推荐
                        </h2>
                        <table class="w-full">
                            <thead>
                                <tr class="text-base-content/60 text-left border-b border-base-300">
                                    <th class="pb-2 w-12">#</th>
                                    <th class="pb-2">歌曲</th>
                                    <th class="pb-2">专辑</th>
                                    <th class="pb-2"></th>
                                    <th class="pb-2 text-right">时长</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(song, index) in randomSongs" 
                                    :key="song.id" 
                                    class="hover:bg-base-200 group border-b border-base-300"
                                    @dblclick="play(index)">
                                    <td class="py-1">{{ index + 1 }}</td>
                                    <td class="py-1 flex items-center space-x-3">
                                        <img :src="song.image" 
                                             class="w-10 h-10 rounded object-cover">
                                        <div>
                                            <div class="font-medium">{{ song.title }}</div>
                                            <div class="text-sm text-base-content/60">{{ song.artist }}</div>
                                        </div>
                                    </td>
                                    <td class="py-1">{{ song.album }}</td>
                                    <td class="py-1">
                                        <button class="invisible group-hover:visible text-base-content/60 hover:text-primary"
                                                @click="$store.commit('toggleFavorite', song)">
                                            <i :class="['far', song.starred ? 'fas text-primary' : 'far']" class="fa-heart"></i>
                                        </button>
                                    </td>
                                    <td class="py-1 text-right">{{ formatDuration(song.duration) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </section>

                    <!-- 推荐专辑展示 -->
                    <section class="p-8">
                        <h2 class="text-2xl font-bold mb-6 flex items-center justify-between text-base-content">
                            <div class="flex items-center">
                                <i class="fas fa-compact-disc text-primary mr-3"></i>
                                <span>推荐专辑</span>
                            </div>
                            <button class="text-sm text-primary hover:text-primary-focus flex items-center">
                                <span>查看全部</span>
                                <i class="fas fa-chevron-right ml-1 text-xs"></i>
                            </button>
                        </h2>

                        <div class="grid grid-cols-4 gap-6">
                            <div class="group">
                                <div class="relative mb-3 overflow-hidden rounded-lg">
                                    <img src="https://images.unsplash.com/photo-1496293455970-f8581aae0e3b?w=300&h=300&fit=crop"
                                        class="w-full aspect-square object-cover transform group-hover:scale-110 transition-transform duration-300">
                                    <div
                                        class="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-40 transition-opacity flex items-center justify-center opacity-0 group-hover:opacity-100">
                                        <button
                                            class="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                                            <i class="fas fa-play text-base-100"></i>
                                        </button>
                                    </div>
                                    <div
                                        class="absolute top-3 right-3 bg-base-100 bg-opacity-70 rounded-full px-2 py-1 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
                                        <i class="fas fa-headphones text-base-100 mr-1"></i>
                                        <span>8.2M</span>
                                    </div>
                                </div>
                                <h3 class="font-bold">To Lose My Life...</h3>
                                <p class="text-sm text-gray-400">White Lies • 2009</p>
                            </div>

                            <div class="group">
                                <div class="relative mb-3 overflow-hidden rounded-lg">
                                    <img src="https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=300&h=300&fit=crop"
                                        class="w-full aspect-square object-cover transform group-hover:scale-110 transition-transform duration-300">
                                    <div
                                        class="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-40 transition-opacity flex items-center justify-center opacity-0 group-hover:opacity-100">
                                        <button
                                            class="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                                            <i class="fas fa-play text-white"></i>
                                        </button>
                                    </div>
                                    <div
                                        class="absolute top-3 right-3 bg-base-100 bg-opacity-70 rounded-full px-2 py-1 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
                                        <i class="fas fa-headphones text-base-100 mr-1"></i>
                                        <span>5.7M</span>
                                    </div>
                                </div>
                                <h3 class="font-bold">Ritual</h3>
                                <p class="text-sm text-gray-400">White Lies • 2011</p>
                            </div>

                            <div class="group">
                                <div class="relative mb-3 overflow-hidden rounded-lg">
                                    <img src="https://images.unsplash.com/photo-1513829596324-4bb2800c5efb?w=300&h=300&fit=crop"
                                        class="w-full aspect-square object-cover transform group-hover:scale-110 transition-transform duration-300">
                                    <div
                                        class="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-40 transition-opacity flex items-center justify-center opacity-0 group-hover:opacity-100">
                                        <button
                                            class="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                                            <i class="fas fa-play text-white"></i>
                                        </button>
                                    </div>
                                    <div
                                        class="absolute top-3 right-3 bg-base-100 bg-opacity-70 rounded-full px-2 py-1 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
                                        <i class="fas fa-headphones text-base-100 mr-1"></i>
                                        <span>6.4M</span>
                                    </div>
                                </div>
                                <h3 class="font-bold">Big TV</h3>
                                <p class="text-sm text-gray-400">White Lies • 2013</p>
                            </div>

                            <div class="group">
                                <div class="relative mb-3 overflow-hidden rounded-lg">
                                    <img src="https://images.unsplash.com/photo-1619983081593-e2ba5b543168?w=300&h=300&fit=crop"
                                        class="w-full aspect-square object-cover transform group-hover:scale-110 transition-transform duration-300">
                                    <div
                                        class="absolute inset-0 bg-black bg-opacity-20 group-hover:bg-opacity-40 transition-opacity flex items-center justify-center opacity-0 group-hover:opacity-100">
                                        <button
                                            class="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                                            <i class="fas fa-play text-white"></i>
                                        </button>
                                    </div>
                                    <div
                                        class="absolute top-3 right-3 bg-base-100 bg-opacity-70 rounded-full px-2 py-1 text-xs opacity-0 group-hover:opacity-100 transition-opacity">
                                        <i class="fas fa-headphones text-base-100 mr-1"></i>
                                        <span>4.9M</span>
                                    </div>
                                </div>
                                <h3 class="font-bold">FIVE</h3>
                                <p class="text-sm text-gray-400">White Lies • 2019</p>
                            </div>
                        </div>
                    </section>

                    <!-- 最新音乐发布 -->
                    <section class="p-8 bg-base-100 rounded-xl mx-8 my-4 shadow-lg">
                        <h2 class="text-2xl font-bold mb-6 flex items-center text-base-content">
                            <i class="fas fa-calendar-alt text-primary mr-3"></i>
                            <span>最新发布</span>
                        </h2>

                        <div class="flex items-center space-x-6">
                            <div class="w-56 h-56 flex-shrink-0">
                                <img src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=300&h=300&fit=crop"
                                    class="w-full h-full object-cover rounded-lg shadow-lg">
                            </div>

                            <div class="flex-1">
                                <div class="flex items-center mb-4">
                                    <span class="badge badge-primary mr-3">新单曲</span>
                                    <span class="text-base-content/60 text-sm">发布于 2024年6月5日</span>
                                </div>

                                <h3 class="text-3xl font-bold mb-3 text-base-content">As I Try Not To Fall Apart</h3>
                                <p class="text-lg text-base-content/80 mb-4">White Lies 的全新单曲，展现了乐队对声音的全新探索和创新。</p>

                                <div class="flex items-center space-x-2 mb-6">
                                    <div class="flex items-center space-x-1">
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star text-warning"></i>
                                        <i class="fas fa-star-half-alt text-warning"></i>
                                    </div>
                                    <span class="text-sm text-base-content/60">4.5 (328 评价)</span>
                                </div>

                                <div class="text-sm text-base-content/60 mb-6">
                                    <p>专辑特点：情感深沉、电子摇滚元素、明亮的合成器和强劲的鼓点，配以Harry McVeigh标志性的嗓音。</p>
                                </div>

                                <div class="flex space-x-4">
                                    <button class="btn btn-primary btn-sm">
                                        <i class="fas fa-play mr-2"></i>
                                        <span>立即播放</span>
                                    </button>
                                    <button class="btn btn-outline btn-sm">
                                        <i class="far fa-heart mr-2"></i>
                                        <span>添加到收藏</span>
                                    </button>
                                    <button class="btn btn-outline btn-sm">
                                        <i class="fas fa-share-alt mr-2"></i>
                                        <span>分享</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <!-- 右侧推荐区域 -->
                <div class="w-96 p-6">
                    <div class="sticky top-0">
                        <div class="mb-6 bg-base-100 p-4 rounded-xl shadow-lg">
                            <h2 class="text-sm font-bold text-base-content/60 mb-2">CURATED ALBUM</h2>
                            <div class="relative mb-4">
                                <img src="https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=400&h=400&fit=crop"
                                    class="w-full h-64 object-cover rounded-lg mb-4">
                                <div
                                    class="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black to-transparent">
                                    <h3 class="text-2xl font-bold mb-2">Big TV</h3>
                                    <p class="text-gray-400">Enjoy vivid emotions with this stunning music album. Each
                                        track is a story.</p>
                                </div>
                                <div class="absolute top-3 right-3 flex space-x-2">
                                    <button
                                        class="w-8 h-8 bg-black bg-opacity-60 rounded-full flex items-center justify-center hover:bg-opacity-80">
                                        <i class="far fa-heart text-white"></i>
                                    </button>
                                    <button
                                        class="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-500">
                                        <i class="fas fa-play text-white text-sm"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="flex items-center justify-between mb-2">
                                <div>
                                    <div class="text-xs text-gray-400 mb-1">专辑 • 2023</div>
                                    <div class="flex items-center">
                                        <div class="flex -space-x-1 mr-2">
                                            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=20&h=20&fit=crop"
                                                class="w-5 h-5 rounded-full border border-[#1e2329]">
                                            <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=20&h=20&fit=crop"
                                                class="w-5 h-5 rounded-full border border-[#1e2329]">
                                            <img src="https://images.unsplash.com/photo-1599566150163-29194dcaad36?w=20&h=20&fit=crop"
                                                class="w-5 h-5 rounded-full border border-[#1e2329]">
                                        </div>
                                        <span class="text-xs text-gray-400">+42.5K 收听</span>
                                    </div>
                                </div>
                                <div class="flex items-center space-x-2">
                                    <button class="text-gray-400 hover:text-white">
                                        <i class="fas fa-share-alt"></i>
                                    </button>
                                    <button class="text-gray-400 hover:text-white">
                                        <i class="fas fa-ellipsis-h"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- 替换为相似艺术家板块 -->
                        <div class="mb-6 bg-base-100 p-4 rounded-xl shadow-lg">
                            <div class="flex items-center justify-between mb-4">
                                <h2 class="text-sm font-bold text-base-content">相似艺术家</h2>
                                <button class="text-xs text-primary hover:text-primary-focus">查看全部</button>
                            </div>
                            <div class="flex space-x-4 mb-4">
                                <div class="flex-1 text-center">
                                    <div class="relative inline-block">
                                        <img src="https://images.unsplash.com/photo-1593698054589-8c14bb66d2fe?w=80&h=80&fit=crop"
                                            class="w-14 h-14 rounded-full object-cover mx-auto border-2 border-green-500">
                                        <div
                                            class="absolute bottom-0 right-0 w-4 h-4 bg-green-500 rounded-full border-2 border-[#1e2329]">
                                        </div>
                                    </div>
                                    <p class="text-xs mt-2 font-medium">Interpol</p>
                                </div>
                                <div class="flex-1 text-center">
                                    <div class="relative inline-block">
                                        <img src="https://images.unsplash.com/photo-1581288906071-9cd16241b28d?w=80&h=80&fit=crop"
                                            class="w-14 h-14 rounded-full object-cover mx-auto">
                                        <div
                                            class="absolute bottom-0 right-0 w-4 h-4 bg-gray-500 rounded-full border-2 border-[#1e2329]">
                                        </div>
                                    </div>
                                    <p class="text-xs mt-2 font-medium">The Killers</p>
                                </div>
                                <div class="flex-1 text-center">
                                    <div class="relative inline-block">
                                        <img src="https://images.unsplash.com/photo-1573164574144-649081e9421c?w=80&h=80&fit=crop"
                                            class="w-14 h-14 rounded-full object-cover mx-auto">
                                        <div
                                            class="absolute bottom-0 right-0 w-4 h-4 bg-gray-500 rounded-full border-2 border-[#1e2329]">
                                        </div>
                                    </div>
                                    <p class="text-xs mt-2 font-medium">Editors</p>
                                </div>
                            </div>
                        </div>

                        <!-- 最近播放 -->
                        <div class="space-y-4 bg-base-100 p-4 rounded-xl shadow-lg">
                            <div class="flex items-center justify-between mb-2">
                                <h2 class="text-sm font-bold text-base-content">最近播放</h2>
                                <button class="text-xs text-primary hover:text-primary-focus">查看历史</button>
                            </div>

                            <div class="flex items-center space-x-4 hover:bg-base-200 p-2 rounded-lg transition-colors">
                                <div class="relative">
                                    <img src="https://images.unsplash.com/photo-1598387846148-47e82ee120cc?w=48&h=48&fit=crop"
                                        class="w-12 h-12 rounded object-cover">
                                    <button
                                        class="absolute inset-0 bg-black bg-opacity-40 rounded flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                                        <i class="fas fa-play text-white"></i>
                                    </button>
                                </div>
                                <div class="flex-1">
                                    <h4 class="font-medium">Death</h4>
                                    <p class="text-sm text-gray-400">Editors</p>
                                </div>
                                <div class="flex items-center space-x-2">
                                    <span class="text-gray-400 text-sm">3:56</span>
                                    <button class="text-gray-400 hover:text-white">
                                        <i class="far fa-heart"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="flex items-center space-x-4 hover:bg-base-200 p-2 rounded-lg transition-colors">
                                <div class="relative">
                                    <img src="https://images.unsplash.com/photo-1598899246709-c8273815f3ef?w=48&h=48&fit=crop"
                                        class="w-12 h-12 rounded object-cover">
                                    <button
                                        class="absolute inset-0 bg-black bg-opacity-40 rounded flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                                        <i class="fas fa-play text-white"></i>
                                    </button>
                                </div>
                                <div class="flex-1">
                                    <h4 class="font-medium">Mr. Brightside</h4>
                                    <p class="text-sm text-gray-400">The Killers</p>
                                </div>
                                <div class="flex items-center space-x-2">
                                    <span class="text-gray-400 text-sm">3:42</span>
                                    <button class="text-gray-400 hover:text-white">
                                        <i class="far fa-heart"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="flex items-center space-x-4 hover:bg-base-200 p-2 rounded-lg transition-colors">
                                <div class="relative">
                                    <img src="https://images.unsplash.com/photo-1508695666381-69deeaa78ccb?w=48&h=48&fit=crop"
                                        class="w-12 h-12 rounded object-cover">
                                    <button
                                        class="absolute inset-0 bg-black bg-opacity-40 rounded flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                                        <i class="fas fa-play text-white"></i>
                                    </button>
                                </div>
                                <div class="flex-1">
                                    <h4 class="font-medium">Obstacle 1</h4>
                                    <p class="text-sm text-gray-400">Interpol</p>
                                </div>
                                <div class="flex items-center space-x-2">
                                    <span class="text-gray-400 text-sm">4:11</span>
                                    <button class="text-gray-400 hover:text-white">
                                        <i class="far fa-heart"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="flex items-center space-x-4 hover:bg-base-200 p-2 rounded-lg transition-colors">
                                <div class="relative">
                                    <img src="https://images.unsplash.com/photo-1594623930572-300a3011d9ae?w=48&h=48&fit=crop"
                                        class="w-12 h-12 rounded object-cover">
                                    <button
                                        class="absolute inset-0 bg-black bg-opacity-40 rounded flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
                                        <i class="fas fa-play text-white"></i>
                                    </button>
                                </div>
                                <div class="flex-1">
                                    <h4 class="font-medium">Somebody Told Me</h4>
                                    <p class="text-sm text-gray-400">The Killers</p>
                                </div>
                                <div class="flex items-center space-x-2">
                                    <span class="text-gray-400 text-sm">3:17</span>
                                    <button class="text-gray-400 hover:text-white">
                                        <i class="far fa-heart"></i>
                                    </button>
                                </div>
                            </div>

                            <!-- 添加个性化推荐模块 -->
                            <div class="mt-6 pt-4 border-t border-base-300">
                                <h3 class="text-sm font-bold mb-3 text-base-content">个性化每日推荐</h3>
                                <div class="bg-gradient-to-r from-primary/20 to-secondary/20 p-3 rounded-lg">
                                    <div class="flex items-center justify-between mb-2">
                                        <div>
                                            <h4 class="text-sm font-bold text-base-content">根据你的口味推荐</h4>
                                            <p class="text-xs text-base-content/60">6首新发现等你聆听</p>
                                        </div>
                                        <button class="btn btn-circle btn-sm btn-ghost">
                                            <i class="fas fa-play text-xs"></i>
                                        </button>
                                    </div>
                                    <div class="flex space-x-1 mt-2">
                                        <img src="https://images.unsplash.com/photo-1460667262220-06e0beb58a64?w=40&h=40&fit=crop"
                                            class="w-10 h-10 rounded-sm">
                                        <img src="https://images.unsplash.com/photo-1571346686046-7a21598754d1?w=40&h=40&fit=crop"
                                            class="w-10 h-10 rounded-sm">
                                        <img src="https://images.unsplash.com/photo-1598518619776-eae3f8a34eac?w=40&h=40&fit=crop"
                                            class="w-10 h-10 rounded-sm">
                                        <img src="https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=40&h=40&fit=crop"
                                            class="w-10 h-10 rounded-sm">
                                        <div
                                            class="w-10 h-10 rounded-sm bg-white bg-opacity-10 flex items-center justify-center text-xs">
                                            +2
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button class="btn btn-outline btn-block btn-sm mt-2">
                                查看更多
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import TrackList from '@/views/library/track/TrackList'
export default {
    components: {
        TrackList
    },
    data() {
        return {
            discover: [],
            randomSongs: []
        }
    },
    computed: {
        isPlaying() {
            return this.$store.state.common.isPlaying
        },
        tracks() {
            return this.$store.state.common.queue
        },
        queueIndex() {
            return this.$store.state.common.queueIndex
        }
    },
    created() {
        this.fetchRandomSongs()
    },
    methods: {
        play(index) {
            if (index === this.queueIndex) {
                return this.$store.dispatch('playPause')
            }
            return this.$store.dispatch('playTrackListIndex', { index })
        },
        dragstart(id, event) {
            event.dataTransfer.setData('application/x-track-id', id)
        },
        remove(idx) {
            return this.$store.commit('removeFromQueue', idx)
        },
        clear() {
            return this.$store.commit('clearQueue')
        },
        shuffle() {
            return this.$store.commit('shuffleQueue')
        },
        formatDuration(value) {
            if (!isFinite(value)) {
                return '∞'
            }
            const minutes = Math.floor(value / 60)
            const seconds = Math.floor(value % 60)
            return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds
        },
        async playNow(id) {
            const playlist = await this.$api.subsonic.getPlaylist(id)
            return this.$store.dispatch('playTrackList', {
                tracks: playlist.tracks
            })
        },
        fetchDiscover() {
            return this.$api.subsonic.getDiscover().then((res) => {
                this.discover = res.discover
            })
        },
        async fetchRandomSongs() {
            try {
                const response = await this.$api.subsonic.getRandomSongs(8)
                this.randomSongs = response || []
            } catch (error) {
                console.error('获取随机歌曲失败:', error)
                this.randomSongs = []
            }
        }
    }
}
</script>
<style scoped>
.body {
    display: flex;
    justify-content: start;
    align-items: center;
}

.shell {
    position: relative;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    /* 设置3d变化 */
    transform-style: preserve-3d;
    /* 添加透视效果 */
    perspective: 900px;
}

.shell .box {
    position: relative;
    width: 200px;
    height: 270px;
    transition: 0.3s;
    overflow: hidden;
    margin: 15px;
    transform: rotateY(0deg);
    transition-delay: .1s;
    border-radius: 5px;
    border: #fff 5px solid;
}

/* 当鼠标所有卡片的父元素点shell上时，
所有卡片像Y轴翻转20度 */
.shell:hover .box {
    transform: rotateY(20deg);
}

/* 当鼠标悬浮在当前卡片上时，当前卡片的翻转角度为0，
并放大一点二五倍，加个阴影 */
.shell .box:hover {
    transform: rotateY(0deg) scale(1.25);
    box-shadow: 0 25px 40px rgba(0, 0, 0, 0.7);
    z-index: 1;
}

/* 当鼠标悬浮在卡片上时，
当前卡片后面的所有卡片全部都反向翻转负20度 */
.shell .box:hover~.box {
    transform: rotateY(-20deg);
}

.shell .box .images img {
    width: 100%;
}

.shell .box .content {
    position: absolute;
    top: 0;
    height: 100%;
    z-index: 999;
    padding: 15px;
}

.shell .box .content h2 {
    color: rgb(210, 140, 140);
    transition: 0.3s;
    font-size: 20px;
    transform: translateY(-100px);
}

.shell .box:hover .content h2 {
    transform: translateY(-15px);
}

.shell .box .content p {
    color: rgb(0, 0, 0);
    transition: 0.3s;
    font-size: 14px;
    transform: translateY(600px);
    background-color: rgba(255, 255, 255, 0.7);
}

.shell .box:hover .content p {
    transform: translateY(185px);
}
</style>
